import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontendTripleDotsComponent } from './frontend-triple-dots.component';

@NgModule({
  declarations: [FrontendTripleDotsComponent],
  exports: [FrontendTripleDotsComponent],
  imports: [
    CommonModule,
  ],
})
export class FrontendTripleDotsModule { }
